import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl1655ValidationSchema = () => {
  const { t } = useTranslation();

  return yup.object().shape({
    d50_id: yup.object().nullable().required(t("Το πεδίο είναι υποχρεωτικό")),

    discontinuationDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .min(
        new Date(1753, 0, 1),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 01/01/1753"),
      )
      .max(
        new Date(),
        t("Η ημερομηνία δεν μπορεί να είναι μεταγενέστερη της σημερινής"),
      )
      .required(t("Το πεδίο είναι υποχρεωτικό")),

    fudocTaxTermination: yup.string().nullable().required(t("Το πεδίο είναι υποχρεωτικό")),

    fudocLoipa: yup.string().nullable(),

    docLoipaFileDate: yup
      .date()
      .nullable()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .min(
        new Date(1753, 0, 1),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 01/01/1753"),
      ),

    comments: yup
      .string()
      .nullable()
      .max(
        2000,
        t("Οι παρατηρήσεις δεν μπορούν να υπερβαίνουν τους 2000 χαρακτήρες"),
      ),
  });
};
